const Header = {

	menu: {

		hide: () => {
			let masthead = document.querySelector('#masthead')
			if( masthead !== null ){
				masthead.classList.remove('active-header-menu')
			}
		},
		toggle: () => {

			let masthead = document.querySelector('#masthead')

			if( masthead !== null ){
				if( masthead.classList.contains('active-header-menu')){
					masthead.classList.remove('active-header-menu')
				}else{
					masthead.classList.add('active-header-menu')
					Header.search.hide()
				}
			}
		}

	},

	search: {

		hide: () => {
			let masthead = document.querySelector('#masthead')
			if( masthead !== null ){
				masthead.classList.remove('active-search-input')
			}
		},
		toggle: () => {

			let masthead = document.querySelector('#masthead')

			if( masthead !== null ){
				if( masthead.classList.contains('active-search-input')){
					masthead.classList.remove('active-search-input')
				}else{
					masthead.classList.add('active-search-input')
					Header.menu.hide()
				}
			}
		}

	},
}
